// @vendors
const Immutable = require('immutable');

// @constants
const { TYPE_FUNDS, TYPE_WARRANTS, TYPE_STOCKS, TYPE_ETFS, TYPE_FUTURES } = require('constants/index');

const {
    BROKER_MIFID_FUND_DISPLAYED,
    BROKER_MIFID_FUND_DISPLAYED_RESET,
    BROKER_MIFID_WARRANT_DISPLAYED,
    BROKER_MIFID_WARRANT_DISPLAYED_RESET,
    BROKER_MIFID_STOCK_DISPLAYED,
    BROKER_MIFID_STOCK_DISPLAYED_RESET,
    BROKER_MIFID_ETF_DISPLAYED,
    BROKER_MIFID_ETF_DISPLAYED_RESET,
    BROKER_MIFID_FUTURES_ACCESS_DISPLAYED,
    BROKER_MIFID_FUTURES_ACCESS_DISPLAYED_RESET
} = require('constants/actionTypes');

const INITIAL_STATE = Immutable.fromJS({
    [TYPE_FUNDS]: Immutable.Map(),
    [TYPE_WARRANTS]: Immutable.Map(),
    [TYPE_STOCKS]: Immutable.Map(),
    [TYPE_ETFS]: Immutable.Map(),
    [TYPE_FUTURES]: Immutable.Map()
});

const displayedOn = (immState, productType, productId, omitted) => {
    if (!productType || !productId) {
        return immState;
    }

    return immState.mergeDeepIn([productType], {
        [productId]: {
            displayed: true,
            completed: true,
            omitted: omitted
        }
    });
};

const resetOn = (immState, productType, productId) => {
    if (!productType || !productId) {
        return immState;
    }

    const displayed = immState.getIn([productType, productId, 'displayed']);
    const completed = immState.getIn([productType, productId, 'completed']);
    const omitted = immState.getIn([productType, productId, 'omitted']);

    return immState.mergeDeepIn([productType], {
        [productId]: {
            displayed: false,
            completed: displayed ? completed : false,
            omitted: displayed ? omitted : false
        }
    });
};

function brokerMiFIDDisplayed(state = INITIAL_STATE, action) {
    switch (action.type) {
        case BROKER_MIFID_FUND_DISPLAYED:
            return displayedOn(state, TYPE_FUNDS, action.payload.fundId, action.payload.omitted);
        case BROKER_MIFID_FUND_DISPLAYED_RESET:
            return resetOn(state, TYPE_FUNDS, action.payload.fundId);
        case BROKER_MIFID_WARRANT_DISPLAYED:
            return displayedOn(state, TYPE_WARRANTS, action.payload.warrantId, action.payload.omitted);
        case BROKER_MIFID_WARRANT_DISPLAYED_RESET:
            return resetOn(state, TYPE_WARRANTS, action.payload.warrantId);
        case BROKER_MIFID_STOCK_DISPLAYED:
            return displayedOn(state, TYPE_STOCKS, action.payload.stockId, action.payload.omitted);
        case BROKER_MIFID_STOCK_DISPLAYED_RESET:
            return resetOn(state, TYPE_STOCKS, action.payload.stockId);
        case BROKER_MIFID_ETF_DISPLAYED:
            return displayedOn(state, TYPE_ETFS, action.payload.etfId, action.payload.omitted);
        case BROKER_MIFID_ETF_DISPLAYED_RESET:
            return resetOn(state, TYPE_ETFS, action.payload.etfId);
        case BROKER_MIFID_FUTURES_ACCESS_DISPLAYED:
            return displayedOn(state, TYPE_FUTURES, action.payload.futureId, action.payload.omitted);
        case BROKER_MIFID_FUTURES_ACCESS_DISPLAYED_RESET:
            return resetOn(state, TYPE_FUTURES, action.payload.futureId);
        default:
            return state;
    }
}

module.exports = brokerMiFIDDisplayed;
